import { Box, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { QuestionnaireResponse } from '../types/MedicalHealthInformation';
import { parseCompleteStatus } from '../func/parse';
import { INFO_KUBUN, MEDICAL_HEALTH_INFORMATION_DETAIL_NAME, STATUS_COLOR, UNANSWERED } from '../constants/constants';
import { useMedicalHealthInformationContext } from '../Context';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranchQuestionnaireResponse = () => {
  const { setActiveStep, activeMedicalHealthInformation, setActiveQuestionnaireResponse, cognitoId } =
    useMedicalHealthInformationContext();
  const handleCardClick = (data: QuestionnaireResponse, status: string) => {
    if (status === UNANSWERED) {
      const url = `${import.meta.env.VITE_PMS_URL}/interview/${
        activeMedicalHealthInformation.facility_id
      }/${cognitoId}/${activeMedicalHealthInformation.outpatient_id}/${activeMedicalHealthInformation.reserve_date}/${
        activeMedicalHealthInformation.reserve_time
      }`;
      window.location.href = url;
      return;
    }
    setActiveQuestionnaireResponse(data);
    setActiveStep(MEDICAL_HEALTH_INFORMATION_DETAIL_NAME);
  };

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            {activeMedicalHealthInformation.questionnaire_response_list.map((data, key) => {
              const status = parseCompleteStatus(data.complete_flag);
              return (
                <Grid
                  item
                  key={key}
                  xs={12}
                  md={6}
                  sx={{ width: `${listCardWidth}px`, justifyContent: 'center', display: 'flex' }}
                >
                  <button
                    onClick={() => handleCardClick(data, status)}
                    type="button"
                    style={{
                      width: `${listCardWidth}px`,
                      padding: '18px 0',
                      backgroundColor: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                      fontSize: '18px',
                      lineHeight: '1.5',
                      fontWeight: 'bold'
                    }}
                  >
                    {data.information_kbn === INFO_KUBUN['PATIENT'] && '事前問診'}
                    {data.information_kbn === INFO_KUBUN['PRACTITIONER'] && '院内問診'}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        position: 'absolute',
                        right: '4px',
                        top: '50%',
                        transform: 'translateY(-50%)'
                      }}
                    >
                      <Box sx={{ fontSize: '10px', lineHeight: '1.5', fontWeight: 'bold' }}>
                        <span style={STATUS_COLOR[status]}>{status}</span>
                      </Box>
                      <ArrowForwardIosIcon />
                    </Box>
                  </button>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationBranchQuestionnaireResponse;
